import { EnumWorkspace, toWorkspace } from '@/contracts/system-modules/auth/enum/EnumWorkspace'

export class TokenState {
  uuid: string
  name: string
  deviceUuid: string
  token: string
  expiresAt: string
  /** Рабочее место устройства */
  workspace: EnumWorkspace

  constructor({ uuid, name, deviceUuid, token, expiresAt, workspace }: {
    uuid: string, name: string, deviceUuid: string, token: string, expiresAt: string, workspace?: string
  }) {
    this.uuid = uuid
    this.name = name
    this.deviceUuid = deviceUuid
    this.token = token
    this.expiresAt = expiresAt
    this.workspace = toWorkspace(workspace)
  }
}
